import clsx from "clsx";

import { useIsAutoblessedModelsEnabled } from "../hooks/use-is-autoblessed-models-enabled";

import {
  DEPRECATED_WIZARD_STEPS,
  WIZARD_STEPS_AUTOBLESSED_MODELS,
} from "./consts";
import { useSelectedMediaPlanModal } from "./use-selected-media-plan-modal";

interface Props {
  className?: string;
  currentIndex: number;
  setStep: (index: number) => void;
}

export const MediaPlanModalTabs = ({
  className,
  currentIndex,
  setStep,
}: Props) => {
  const { selectedMediaPlan, isDraft } = useSelectedMediaPlanModal();
  const areAutoblessedModelsEnabled = useIsAutoblessedModelsEnabled();
  const WIZARD_STEPS = areAutoblessedModelsEnabled
    ? WIZARD_STEPS_AUTOBLESSED_MODELS
    : DEPRECATED_WIZARD_STEPS;

  const checkIfVerified = (index: number) => {
    if (selectedMediaPlan) {
      if (!isDraft) {
        // If media plan is not in draft state then return true
        return true;
      } else if (
        index === 0 &&
        selectedMediaPlan?.id !== undefined &&
        selectedMediaPlan?.id !== ""
      ) {
        // If on first step and id exists then return true
        return true;
      } else if (WIZARD_STEPS[index].key) {
        return selectedMediaPlan.step_tracker[WIZARD_STEPS[index].key].verified;
      }
    }
    return false;
  };

  const isTabDisabled = (index: number) => {
    return !selectedMediaPlan?.id && index !== 0;
  };

  return (
    <div
      className={clsx(className, "flex flex-col justify-between min-w-[286px]")}
    >
      <div className="p-6 pb-0">
        <div className="text-lg font-semibold">
          {isDraft ? "Create " : ""} Media Plan
        </div>
        <div className="text-sm text-interstellar-1 mb-4">
          Find better performance. Use MMM+ to power your channel mix.
        </div>
        {WIZARD_STEPS.map((tab, index) => (
          <div
            key={index}
            className={clsx(
              "flex items-center space-x-2 rounded py-2.5 pl-2.5 pr-4",
              index === currentIndex && "bg-interstellar-3",
              index !== currentIndex &&
                !isTabDisabled(index) &&
                "cursor-pointer",
              {
                "opacity-50 cursor-not-allowed": isTabDisabled(index),
              },
            )}
            onClick={() => !isTabDisabled(index) && setStep(index)}
          >
            <div className="bg-v2-primary rounded w-9 h-9 border border-interstellar-3 flex-center relative">
              {checkIfVerified(index) && (
                <div className="absolute -bottom-1 -right-1 bg-alien w-3.5 h-3.5 rounded-full flex-center text-xs">
                  <i className="fa-regular fa-check text-white" />
                </div>
              )}
              {tab.icon}
            </div>
            <div
              className={clsx("text-sm", {
                "font-semibold": index === currentIndex,
              })}
            >
              {tab.title}
            </div>
          </div>
        ))}
      </div>
      <div className="px-6 bg-[#FAFAFA] h-16 flex items-center">
        <div className="flex-grow">
          <div className="text-xs text-interstellar-1 mb-2">
            Step {currentIndex + 1} of {WIZARD_STEPS.length}
          </div>
          <div className="h-1.5 bg-cosmic-4.5 rounded-full relative">
            <div
              className="h-1.5 bg-cosmic rounded-full"
              style={{
                width: `${((currentIndex + 1) / WIZARD_STEPS.length) * 100}%`,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
